// BlurContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const BlurContext = createContext();

const BLUR_STORAGE_KEY = 'kaxaa_blur_state';

export const BlurProvider = ({ children }) => {
    // Initialize from localStorage or default to true
    const [blurred, setBlurred] = useState(() => {
        try {
            const savedBlurState = localStorage.getItem(BLUR_STORAGE_KEY);
            return savedBlurState !== null ? JSON.parse(savedBlurState) : true;
        } catch (error) {
            console.error('Error reading blur state from localStorage:', error);
            return true;
        }
    });

    // Save to localStorage whenever blur state changes
    useEffect(() => {
        try {
            localStorage.setItem(BLUR_STORAGE_KEY, JSON.stringify(blurred));
        } catch (error) {
            console.error('Error saving blur state to localStorage:', error);
        }
    }, [blurred]);

    // Sync DOM elements with blur state on mount and state changes
    useEffect(() => {
        const syncDOMElements = () => {
            document.querySelectorAll('.secret').forEach(el => {
                if (blurred) {
                    el.classList.add('blurred');
                } else {
                    el.classList.remove('blurred');
                }
            });
        };

        // Sync immediately
        syncDOMElements();

        // Also sync after a short delay to catch any dynamically added elements
        const timeoutId = setTimeout(syncDOMElements, 100);

        return () => clearTimeout(timeoutId);
    }, [blurred]);

    const toggleBlur = () => setBlurred(prev => !prev);

    return (
        <BlurContext.Provider value={{ blurred, toggleBlur }}>
            {children}
        </BlurContext.Provider>
    );
};

export const useBlur = () => useContext(BlurContext);
